import './index.css'
import App from './App'
import { keycloak } from './lib'
import { createRoot } from 'react-dom/client'
import { logError } from './lib/logError'
import { BrowserRouter as Router } from 'react-router-dom'

const container = document.getElementById('root')
const root = createRoot(container!)
if (!root) {
  throw new Error('Could not get #root element')
}

keycloak.init({ onLoad: 'login-required' }).then(
  () => {
    root.render(
      <Router>
        <App doLogout={keycloak.logout} />
      </Router>
    )
  },
  (err: any) => {
    if (err === 'Unauthenticated') {
      keycloak.login()
    } else {
      err
        ? logError(new Error('Authentication failed'), err)
        : logError(new Error('Authentication failed'), new Error('Unknown error'))

      root.render(<div className="alert alert-danger">Wooopsie, authentication failed for some reason!</div>)
    }
  }
)
